module.exports = __webpack_public_path__ + "media/images/haircut/laura@2x-7ec476c1f90b937361b081642a506602.jpg";